(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.body.classList.add('peppi-coming-soon-active');
  });
})();

document.addEventListener('DOMContentLoaded', function () {
  const rotatingWord = document.querySelector('.peppi-rotating-word');

  if (!rotatingWord) return;

  const words = [
    'effortlessly',
    'comfortably',
    'beautifully'
  ];

  let index = 0;
  let isAnimating = false;

  function buildWord(word, incoming = false) {
    rotatingWord.innerHTML = '';

    [...word].forEach(function (letter) {
      const span = document.createElement('span');
      span.className = 'peppi-rotating-letter';

      if (incoming) {
        span.classList.add('letter-in');
      }

      span.textContent = letter;
      rotatingWord.appendChild(span);
    });
  }

  function changeWord() {
    if (isAnimating) return;
    isAnimating = true;

    const letters = rotatingWord.querySelectorAll('.peppi-rotating-letter');

    // Dissolve current word left → right
    letters.forEach(function (letter, i) {
      setTimeout(function () {
        letter.classList.add('letter-out');
      }, i * 45);
    });

    const dissolveTime = (letters.length * 45) + 550;

    setTimeout(function () {
      index = (index + 1) % words.length;

      // Build new invisible word
      buildWord(words[index], true);

      const newLetters = rotatingWord.querySelectorAll('.peppi-rotating-letter');

      // Dissolve new word in left → right
      newLetters.forEach(function (letter, i) {
        setTimeout(function () {
          letter.classList.remove('letter-in');
        }, i * 45);
      });

      setTimeout(function () {
        isAnimating = false;
      }, (newLetters.length * 40) + 600);

    }, dissolveTime);
  }

  buildWord(words[0]);

  setInterval(changeWord, 4000);
});